import { Link } from "react-router-dom";
import AuthUser from "./AuthUser";

/**
 * NotFoundPage — the animated 404 illustration covering the full page
 * (100vw x 100vh). The graphic itself carries a "go home" button, so the
 * whole image is clickable and navigates home (dashboard when signed in,
 * login otherwise).
 */
function NotFoundPage() {
    const { getToken } = AuthUser();
    const authed = !!getToken();

    return (
        <div className="px-404">
            <Link
                className="px-404__link"
                to={authed ? '/Customer-Dash' : '/'}
                aria-label="Go home"
                title="Go home"
            >
                <img className="px-404__img" src="/assets/img/404.svg" alt="404 Page not found" />
            </Link>
        </div>
    );
}

export default NotFoundPage;
